import { getDirectDebitReuse } from './direct.debit.autofill.selector';
import { getDirectDebitAttempts } from './direct.debit.attempts.selector';
import { DirectDebitFormState } from '@dgx-pr-spa/shared/util';
import { COMPLETE_ORDER_FEATURE } from '../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { DirectDebitValidationState } from '../reducers/direct.debit.validation.reducer';
import * as fromCompleteOrder from '@complete-order/store/reducers';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );

export const getDirectDebitValidationState = createSelector(
  getCompleteOrderState,
  (state) => state?.directDebitValidation
);

export const getDirectDebitValidation = createSelector(
  getDirectDebitValidationState,
  (directDebitValidation: DirectDebitValidationState) =>
    directDebitValidation?.data?.isValid
);

export const getDirectDebitValidationLoading = createSelector(
  getDirectDebitValidationState,
  (directDebit: DirectDebitValidationState) => directDebit?.loading
);

export const getDirectDebitValidationLoaded = createSelector(
  getDirectDebitValidationState,
  (directDebit: DirectDebitValidationState) => directDebit?.loaded
);

export const getDirectDebitValidationError = createSelector(
  getDirectDebitValidationState,
  (directDebitValidation: DirectDebitValidationState) =>
    directDebitValidation?.error
);

export const getDirectDebitFormState = createSelector(
  [
    getDirectDebitValidation,
    getDirectDebitAttempts,
    getDirectDebitReuse,
    getDirectDebitValidationError,
  ],
  (valid, attempts, reuse, error) => {
    const retries = 3;
    let formState: DirectDebitFormState;

    if (error) {
      formState = DirectDebitFormState.ERROR;
    } else if ((valid && reuse === true) || (valid === undefined && reuse)) {
      formState = DirectDebitFormState.AUTOFILLVALID;
    } else if (valid === false && attempts > retries) {
      formState = DirectDebitFormState.RETRIES_EXCEEDED;
    } else if (valid === false) {
      formState = DirectDebitFormState.INVALID;
    } else if (valid === true) {
      formState = DirectDebitFormState.VALID;
    } else {
      formState = DirectDebitFormState.UNKNOWN;
    }

    return formState;
  }
);
